<template>
  <div class="loginContainer flexCenter">
    <div style="height:100vh">
      <div style="margin-top:3.85rem;text-align:center">
        <img
          @dblclick="openDevTool"
          src="../../assets/login_logo.png"
          style="width:19.1rem;height:5.35rem"
        />
      </div>
      <div
        style="margin-top:5.85rem;width:41rem;height:29.5rem;position: relative;"
      >
        <div
          style="width:41rem;height:29.5rem;background:#0A6BCA;border-radius:3rem;top:0.5rem;left:0.2rem;position:absolute"
        ></div>
        <div
          style="width:41rem;height:29.5rem;background:#53B8F8;border-radius:3rem;position:absolute;left:0;top:0"
          class="flexCenter"
        >
          <div
            v-if="login_type == 'mobile'"
            style="width:38.5rem;height:27rem;position: relative;"
          >
            <div
              style="width:38.5rem;height:27rem;background:#B5D7F3;border-radius:2rem;position:absolute;left:0.3rem;top:0.3rem"
            ></div>
            <div
              style="width:38.5rem;height:27rem;background:#ffffff;border-radius:2rem;position:absolute;left:0rem;top:0rem"
            >
              <div style="padding:3.75rem 2.75rem;">
                <div>
                  <input
                    style="width:calc(100% - 4rem );height:4rem;background:#eeeeee;border-radius:1.5rem;padding:0rem 2rem;font-size:1.6rem;border:none;outline:none;color:#333333"
                    v-model="mobile"
                    placeholder="手机号"
                  />
                </div>
                <div style="margin-top:2rem;" class="flexBetween">
                  <input
                    style="width:calc( 100% - 4rem - 12.6rem);height:4rem;background:#eeeeee;border-radius:1.5rem;padding:0rem 2rem;font-size:1.6rem;border:none;outline:none;color:#333333"
                    v-model="sms_code"
                    placeholder="短信验证码"
                    @keyup.enter="doLogin"
                  />
                  <div class="sendSmsBtn" @click="getSmsCode">
                    {{ sms_text }}
                  </div>
                </div>

                <div style="margin-top:2rem;">
                  <div class="loginBtn" @click="doLogin">登录</div>
                  <div
                    style="display:flex;align-items:center;justify-content:space-around;margin-top:0.5rem"
                  >
                    <div
                      @click="login_type = 'pwd'"
                      style="font-size:1.5rem;color: #2a9bff;margin-top:0.5rem;text-align:center;cursor: pointer;"
                    >
                      密码登录
                    </div>
                    <div
                      @click="login_type = 'qrcode'"
                      style="font-size:1.5rem;color: #2a9bff;margin-top:0.5rem;text-align:center;cursor: pointer;"
                    >
                      扫码登录
                    </div>
                  </div>

                  <div
                    style="margin-top: 0.5rem;display:flex;align-items:center;justify-content:space-between"
                  >
                    <div style="font-size: 1rem;color: #FFA143">
                      提示：更多操作请点击鼠标右键或长按触摸屏
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="login_type == 'pwd'"
            style="width:38.5rem;height:27rem;position: relative;"
          >
            <div
              style="width:38.5rem;height:27rem;background:#B5D7F3;border-radius:2rem;position:absolute;left:0.3rem;top:0.3rem"
            ></div>
            <div
              style="width:38.5rem;height:27rem;background:#ffffff;border-radius:2rem;position:absolute;left:0rem;top:0rem"
            >
              <div style="padding:3.75rem 2.75rem;">
                <div>
                  <input
                    style="width:calc(100% - 4rem );height:4rem;background:#eeeeee;border-radius:1.5rem;padding:0rem 2rem;font-size:1.6rem;border:none;outline:none;color:#333333"
                    v-model="mobile"
                    placeholder="手机号"
                  />
                </div>
                <div style="margin-top:2rem;" class="flexBetween">
                  <input
                  type="password"
                    style="width:calc( 100% - 4rem - 12.6rem);height:4rem;background:#eeeeee;border-radius:1.5rem;padding:0rem 2rem;font-size:1.6rem;border:none;outline:none;color:#333333"
                    v-model="password"
                    placeholder="登录密码"
                    @keyup.enter="doPwdLogin"
                  />
                  <div style="display:flex;align-items:center;font-size:1.6rem;color:#666666">
                    <input v-model="isRemember" type="checkbox" style="width:1.6rem;height:1.6rem;margin-right:0.5rem" id="rememberPwd" />
                    <label for="rememberPwd">记住密码</label>
                  </div>
                </div>

                <div style="margin-top:2rem;">
                  <div class="loginBtn" @click="doPwdLogin">登录</div>
                  <div
                    style="display:flex;align-items:center;justify-content:space-around;margin-top:0.5rem"
                  >
                    <div
                      @click="login_type = 'mobile'"
                      style="font-size:1.5rem;color: #2a9bff;margin-top:0.5rem;text-align:center;cursor: pointer;"
                    >
                      手机登录
                    </div>
                    <div
                      @click="login_type = 'qrcode'"
                      style="font-size:1.5rem;color: #2a9bff;margin-top:0.5rem;text-align:center;cursor: pointer;"
                    >
                      扫码登录
                    </div>
                  </div>

                  <div
                    style="margin-top: 0.5rem;display:flex;align-items:center;justify-content:space-between"
                  >
                    <div style="font-size: 1rem;color: #FFA143">
                      提示：更多操作请点击鼠标右键或长按触摸屏
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else style="width:38.5rem;height:27rem;position: relative;">
            <div
              style="width:38.5rem;height:27rem;background:#B5D7F3;border-radius:2rem;position:absolute;left:0.3rem;top:0.3rem"
            ></div>
            <div
              style="width:38.5rem;height:27rem;background:#ffffff;border-radius:2rem;position:absolute;left:0rem;top:0rem"
            >
              <div style="padding:3.75rem 2.75rem;">
                <div style="text-align:center">
                  <vue-qr
                    :text="qrcodeContent"
                    :size="rootFontSize * 16.5"
                    :margin="0"
                  ></vue-qr>
                </div>

                <div style="margin-top:1.0rem;">
                  <div
                    style="display:flex;align-items:center;justify-content:space-around;"
                  >
                    <div
                      @click="login_type = 'pwd'"
                      style="font-size:1.5rem;color: #2a9bff;margin-top:0.5rem;text-align:center;cursor: pointer;"
                    >
                      密码登录
                    </div>
                    <div
                      @click="login_type = 'mobile'"
                      style="font-size:1.5rem;color: #2a9bff;margin-top:0.5rem;text-align:center;cursor: pointer;"
                    >
                      手机登录
                    </div>
                  </div>
                 
                  <div
                    style="display:flex;align-items:center;justify-content:space-between"
                  >
                    <div style="font-size: 1rem;color: #FFA143">
                      提示：请通过“晓笔老师”小程序，“我的”->“扫一扫”扫码登录。<br/>
                      也可以通过“规范书写教师端”小程序首页的“扫一扫”扫码登录。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      v-if="isElectron"
      style="cursor: pointer;position: fixed;width: 5.5rem;height: 5.3rem;background: rgba(0,0,0,0.5);top: 0;right: 2rem;border-radius: 0 0 2rem 2rem"
      class="flexCenter"
      @click="doExit"
    >
      <img
        src="../../assets/icon_close_white.png"
        style="width: 2rem;height: 2rem;padding-top: 1rem"
      />
    </div> -->

    <div
      v-if="isElectron"
      style="position:fixed;bottom:2rem;left:50%;transform:translateX(-50%);line-height:40px;color:#fff"
    >
      版本号:V{{ localVersion }}
      <a
        @click="checkUpdate(true)"
        style="margin-left:20px;cursor:pointer;text-decoration: underline;"
        >检查更新</a
      >
    </div>
    <bottom-bar v-if="isElectron" :is-login="true"></bottom-bar>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import { v1 } from 'uuid'
import md5 from 'js-md5';

import BottomBar from '../../components/BottomBar.vue'

export default {
  name: 'Login',
  components: { VueQr, BottomBar },
  data() {
    return {
      login_type: 'mobile',
      mobile: '',
      password:'',
      qrcodeContent: '',
      sms_code: '',
      count_down: 60,
      sms_text: '获取验证码',
      send_flag: true,
      login_flag: true,
      localVersion: '',
      rootFontSize: 12,
      isRemember:true
    }
  },
  computed: {
    isElectron() {
      var userAgent = navigator.userAgent.toLowerCase()
      if (userAgent.indexOf(' electron/') > -1) {
        return true
      } else return false
    },
  },
  watch: {
    login_type(val) {
      if (val == 'qrcode') {
        this.qrcodeContent = JSON.stringify({
          act: 'bigScreenLogin',
          uuid: v1(),
        })

        this.checkScanLogin()
      } else {
        this.qrcodeContent = ''
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      // 版本更新
      // if (this.isElectron) {
      //   setTimeout(() => {
      //     let localVersion =
      //       sessionStorage.getItem('xiaobi_app_version') || '1.0.0'
      //     this.localVersion = localVersion
      //     this.checkUpdate()
      //   }, 1500)
      // }

      let rootFontSize = getComputedStyle(window.document.documentElement)[
        'font-size'
      ]
      if (rootFontSize) {
        this.rootFontSize = rootFontSize.replace('px', '')
      }

      let mobile = localStorage.getItem('xiaobi_login_mobile')
      if (mobile) {
        this.mobile = mobile
      }

      let password = localStorage.getItem('xiaobi_login_pwd')
      if (password) {
        this.password = password
        this.isRemember=true
      }
    })
  },
  methods: {
    checkScanLogin() {
      if (this.qrcodeContent && this.$route.path == '/login') {
        this.$http
          .post('/api/v2/handwriting/Pub/codeLogin', {
            UUID: JSON.parse(this.qrcodeContent).uuid,
          })
          .then((res) => {
            if (res.code == '200') {
              let access_token = res.data.access_token
              let teacher = res.data.teacher
              sessionStorage.setItem('xiaobi_access_token', access_token)
              sessionStorage.setItem('xiaobi_teacher', JSON.stringify(teacher))
              this.$http.post('/api/v2/handwriting/Pub/addOperationLog', {
                content: '大屏扫码登录成功',
                type: 10,
                operation_id: teacher.id,
              })
              this.$router.replace('/word_search')
            } else {
              setTimeout(() => {
                this.checkScanLogin()
              }, 1000)
            }
          })
          .catch(() => {})
      }
    },
    openDevTool() {
      window.dispatchEvent(new Event('openDevTool'))
    },
    checkUpdate(flag) {
      let _this = this
      let plantVersion = 'win64'
      var agent = navigator.userAgent.toLowerCase()
      var isMac = (function() {
        return /macintosh|mac os x/i.test(navigator.userAgent)
      })()
      if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
        plantVersion = 'win32'
      } else if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
        plantVersion = 'win64'
      }
      if (isMac) {
        plantVersion = 'mac'
      }

      let localVersion = sessionStorage.getItem('xiaobi_app_version') || '1.0.0'
      fetch(
        'https://open.xiaobixiezi.com/teacher_pc/update.json?v=' +
          Math.random(),
        {
          method: 'GET',
          mode: 'cors', // 允许发送跨域请求
          credentials: 'include',
        }
      )
        .then(function(response) {
          //打印返回的json数据
          response.json().then(function(data) {
            let remoteVersionInfo = data[plantVersion]
            if (
              parseInt(remoteVersionInfo.version.replaceAll('.', '')) >
              parseInt(localVersion.replaceAll('.', ''))
            ) {
              _this.$layer.confirm(
                remoteVersionInfo.note,
                {
                  title: '更新提醒',
                  btn: ['立即更新', '下次再说'], //按钮
                },
                function() {
                  let link = document.createElement('a')
                  link.href = remoteVersionInfo.url
                  document.body.append(link)
                  link.click()
                  document.body.removeChild(link)
                  _this.$layer.closeAll()
                },
                function() {
                  _this.$layer.closeAll()
                }
              )
            } else {
              if (flag) {
                _this.$layer.msg('当前已是最新版本！')
              }
            }
          })
        })
        .catch(function(e) {
          console.log('error: ' + e.toString())
        })
    },
    doExit() {
      window.dispatchEvent(new Event('exitApp'))
    },
    checkPhone(phone) {
      if (phone.length != 11) {
        return false
      } else {
        return true
      }
    },
    checkSmsCode(sms_code) {
      if (sms_code.length != 4) {
        return false
      } else {
        return true
      }
    },
    getSmsCode() {
      if (!this.send_flag) {
        return
      }
      this.send_flag = false
      if (this.checkPhone(this.mobile)) {
        this.$http
          .post('/apipub/handwriting/sms/send', {
            mobile: this.mobile,
            event: 'teacher_login',
          })
          .then((res) => {
            if (res.code == '200') {
              this.$layer.msg('短信验证码已发送')
              this.countDown()
            } else {
              this.send_flag = true
            }
          })
      } else {
        this.$layer.msg('请输入正确的手机号码')
        this.send_flag = true
      }
    },
    countDown() {
      this.sms_text = '重新发送(' + this.count_down + ')'
      this.count_down--
      if (this.count_down > 0) {
        setTimeout(() => {
          this.countDown()
        }, 1000)
      } else {
        this.count_down = 60
        this.sms_text = '重新发送'
        this.send_flag = true
      }
    },
    doPwdLogin(){
      if (!this.login_flag) return

      if (!this.checkPhone(this.mobile)) {
        this.$layer.msg('请输入正确的手机号码')
        return
      }
      if (!this.password) {
        this.$layer.msg('请输入登录密码')
        return
      }

      this.login_flag = false

      this.$http
        .post('/api/v2/handwriting/Teacher/LoginByMsg', {
          mobile: this.mobile,
          passwd: md5(this.password),
        })
        .then((res) => {
          if (res.code == '200') {
            if(this.isRemember){
              localStorage.setItem("xiaobi_login_pwd",this.password)
            }

            let access_token = res.data.access_token
            let teacher = res.data.teacher
            sessionStorage.setItem('xiaobi_access_token', access_token)
            sessionStorage.setItem('xiaobi_teacher', JSON.stringify(teacher))
            localStorage.setItem('xiaobi_login_mobile', this.mobile)
            this.$http.post('/api/v2/handwriting/Pub/addOperationLog', {
              content: '大屏登录成功',
              type: 10,
              operation_id: teacher.id,
            })
            this.$router.replace('/word_search')
          } else {
            this.login_flag = true
          }
        })
    },
    doLogin() {
      if (!this.login_flag) return

      if (!this.checkPhone(this.mobile)) {
        this.$layer.msg('请输入正确的手机号码')
        return
      }
      if (!this.checkSmsCode(this.sms_code)) {
        this.$layer.msg('请输入正确的短信验证码')
        return
      }

      this.login_flag = false

      this.$http
        .post('/api/v2/handwriting/Teacher/LoginByMsg', {
          mobile: this.mobile,
          code: this.sms_code,
        })
        .then((res) => {
          if (res.code == '200') {
            let access_token = res.data.access_token
            let teacher = res.data.teacher
            sessionStorage.setItem('xiaobi_access_token', access_token)
            sessionStorage.setItem('xiaobi_teacher', JSON.stringify(teacher))
            localStorage.setItem('xiaobi_login_mobile', this.mobile)
            this.$http.post('/api/v2/handwriting/Pub/addOperationLog', {
              content: '大屏登录成功',
              type: 10,
              operation_id: teacher.id,
            })
            this.$router.replace('/word_search')
          } else {
            this.login_flag = true
          }
        })
    },
  },
}
</script>
<style scoped>
.loginContainer {
  width: 100vw;
  height: 100vh;
  background: url('../../assets/login_bg.png') no-repeat;
  background-size: 100% 100%;
}

.sendSmsBtn {
  cursor: pointer;
  width: 11.6rem;
  height: 4rem;
  line-height: 4rem;
  text-align: center;
  font-size: 1.8rem;
  border-radius: 1.5rem;
  color: #ffffff;
  background: linear-gradient(to right, #ffa143, #ffc11d);
}

.sendSmsBtn:hover {
  background: linear-gradient(to right, #f38b22, #f38b22);
}

.loginBtn {
  cursor: pointer;
  width: 33rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
  font-size: 2.2rem;
  border-radius: 2rem;
  color: #ffffff;
  background: #2a9bff;
}

.loginBtn:hover {
  background: #158ffa;
}
</style>
